import { render, staticRenderFns } from "./pagerBar.vue?vue&type=template&id=35434aa6&"
import script from "./pagerBar.vue?vue&type=script&lang=js&"
export * from "./pagerBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports